import { CreateCustomerForm } from "@/components/customers/CreateCustomerForm";
import { Button } from "@/components/ui/button";
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";

export const Route = createFileRoute("/dashboard/admin/customers/create")({
  head: () => ({
    meta: [
      {
        title: "Create Customer - GetHandle Admin",
      },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();

  const handleSuccess = (customerUid: string) => {
    if (customerUid) {
      navigate({
        to: "/dashboard/admin/customers/$customerId",
        params: { customerId: customerUid },
      });
    } else {
      navigate({ to: "/dashboard/admin/customers" });
    }
  };

  return (
    <div className="container mx-auto max-w-3xl space-y-6 p-1 sm:p-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:gap-3">
        <Link to="/dashboard/admin/customers" className="self-start">
          <Button variant="outline" size="icon">
            <ArrowLeft className="h-4 w-4" />
          </Button>
        </Link>
        <div className="space-y-2">
          <h2 className="text-2xl font-bold tracking-tight sm:text-3xl">Create New Customer</h2>
          <p className="text-sm leading-relaxed text-muted-foreground sm:text-base">
            Add a new customer with detailed information including contact details and address. You
            can create authless customers for record-keeping or provide login access for full portal
            usage.
          </p>
        </div>
      </div>

      <div className="rounded-lg border p-4 sm:p-6">
        <CreateCustomerForm
          onSuccess={handleSuccess}
          onCancel={() => navigate({ to: "/dashboard/admin/customers" })}
        />
      </div>
    </div>
  );
}
